import React from 'react';
import { RequiredFieldsCard } from './components/RequiredFieldsCard';
export function App() {
  return <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8 font-sans selection:bg-indigo-100 selection:text-indigo-900" data-id="element-0">
      <div className="max-w-4xl mx-auto" data-id="element-1">
        <RequiredFieldsCard data-id="element-2" />
      </div>
    </div>;
}